import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-addproductquickmenu',
  templateUrl: './addproductquickmenu.component.html',
  styleUrls: ['./addproductquickmenu.component.css']
})
export class AddproductquickmenuComponent implements OnInit {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  errtxt: any = "";



  //Edit Get Values
  productColl: any = [];
  //pageColl:any=[];

  quickmenuform = new FormGroup({
    quickmenuid: new FormControl(0),
    productid: new FormControl(null, Validators.required),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "ProductQuickMenu";

  @Input() quickmenuid: number = 0
  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private activeModal: NgbActiveModal,) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.quickmenuid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.quickmenuform.reset();
      this.fnInitializeProductQuickMenu();


      this.fngetProduct();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.quickmenuid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }



    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeProductQuickMenu() {
    this.quickmenuform.setValue({
      quickmenuid: 0,
      productid: null,
    })
  }



  fngetProduct() {
    var data = {
      'productid': 0,

    }
    this.appService.getProduct(data)
      .subscribe(
        (res) => {
          this.productColl = res.json().result[0];
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

      //  this.fnResetValidation()
      //Validate
      if (this.quickmenuform.valid) {

        //  this.fnValidation()
        //Check
        var data = {
          'quickmenuid': this.quickmenuid,
          'productid': this.quickmenuform.get('productid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckProductQuickMenu(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
           
              this.fnInsertProductQuickMenu(data);
            }
            else if (_checkresult === "name") {
              this.quickmenuform.controls['productid'].setErrors({ 'notfound': true });

            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertProductQuickMenu(data) {

    this.appService.fnInsertProductQuickMenu(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.toastr.success('', "The new Product has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.productname);

          this.emitData.emit(this.quickmenuid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }



  //Close

  //Close
  public decline() {
    this.activeModal.close(false);
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
